import axios from "axios";

import auth from "@/helpers/auth";
import router from "@/router/index";
import store from "@/store/index";

export default {
  instance() {
    const instance = axios.create({
      baseURL: process.env.API_BASE_URL,
      timeout: 30000
    });

    instance.interceptors.response.use(
      (response) => response,
      (error) => {
        // Do something with response error
        if (error.response.status === 401) {
          console.error("Unauthorized request, signing out.");
          store.dispatch("signOut");
          router.push("/sign-in");
        }

        return Promise.reject(error);
      }
    );

    const token = auth.getToken();

    if (token) {
      instance.defaults.headers.common.Authorization = "Bearer " + token;
    }

    return instance;
  }
};
